import React from 'react'

// Türbin detay verisi yüklenirken gösterilen skeleton.
// Tam-ekran modal yerine, yüklenecek sayfanın düzenini (header + türbin kartı + foto grid'leri)
// taklit ederek "flaş" hissini azaltır.
const Tile: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div className={`bg-gray-200 rounded ${className}`} />
)

const LoadingScreen: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header skeleton */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="h-16 flex items-center justify-between animate-pulse">
            <div className="flex items-center space-x-3">
              <Tile className="w-9 h-9 rounded-lg" />
              <Tile className="h-5 w-40" />
            </div>
            <div className="flex items-center space-x-2">
              <Tile className="w-24 h-9 rounded-lg" />
              <Tile className="w-9 h-9 rounded-lg" />
            </div>
          </div>
        </div>
      </div>

      {/* Main content skeleton */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 animate-pulse">
        {/* Türbin başlık kartı */}
        <div className="bg-white rounded-xl shadow-sm border p-8 mb-8">
          <div className="flex items-start justify-between">
            <div className="flex items-center space-x-4">
              <Tile className="w-20 h-20 rounded-2xl flex-shrink-0" />
              <div className="space-y-3">
                <Tile className="h-7 w-56" />
                <Tile className="h-5 w-40" />
              </div>
            </div>
            <div className="flex flex-col items-end space-y-2">
              <Tile className="h-5 w-24" />
              <Tile className="h-4 w-32" />
            </div>
          </div>
        </div>

        {/* Foto bölümü kartları */}
        {[0, 1].map((section) => (
          <div key={section} className="bg-white rounded-xl shadow-sm border p-6 mb-8">
            <div className="flex items-center justify-between mb-6">
              <Tile className="h-6 w-48" />
              <Tile className="h-9 w-32 rounded-lg" />
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
              {Array.from({ length: 8 }).map((_, i) => (
                <Tile key={i} className="aspect-square rounded-lg" />
              ))}
            </div>
          </div>
        ))}
      </main>
    </div>
  )
}

export default LoadingScreen
